import axios from 'axios';

async function UsarCodigoValidacion(dni: string, ape_y_nom: string, email: string, celular: string, tipo_validacion: string, codigo_validacion: string) {
    
    const url = "https://endpoints.mapsys.com.ar/validar/usar_codigo_validacion"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "dni": dni,
            "apeynom": ape_y_nom,
            "email": email,
            "celular": celular,
            "tipo_validacion": tipo_validacion,
            "codigo_validacion": codigo_validacion
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export default UsarCodigoValidacion;